import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img-web/logo-white@2x.png';
import _imports_1 from '@/assets/img-web/logo-black@2x.png';
import _imports_2 from '@/assets/img-web/menu-black@2x.png';
import _imports_3 from '@/assets/img-web/menu-white@2x.png';
const _withScopeId = n => (_pushScopeId("data-v-402328cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "website-index"
};
const _hoisted_2 = {
  class: "web-header-content"
};
const _hoisted_3 = {
  key: 0,
  class: "logo",
  src: _imports_0,
  alt: ""
};
const _hoisted_4 = {
  key: 1,
  class: "logo",
  src: _imports_1,
  alt: ""
};
const _hoisted_5 = {
  class: "web-header-btn"
};
const _hoisted_6 = {
  class: "drawer-title"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "blackLine"
}, "|", -1));
const _hoisted_8 = {
  class: "website-drawer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_drawer = _resolveComponent("el-drawer");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_container = _resolveComponent("el-container");
  const _component_Login = _resolveComponent("Login");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
    class: "web-layout-container"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: _normalizeClass(["web-layout-header", {
        whiteHeader: _ctx.needWhiteHeader,
        homeScroll: _ctx.isScroll,
        scrolTop: _ctx.isScroll === false && !_ctx.needWhiteHeader && !_ctx.goHome
      }])
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass(["left-header", {
          hideLogo: _ctx.drawer
        }]),
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _ctx.home && _ctx.home(...args))
      }, [!_ctx.needWhiteHeader && !_ctx.isScroll ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true), _ctx.needWhiteHeader || _ctx.isScroll ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("span", {
        class: _normalizeClass(["whiteLine", {
          blackLine: _ctx.needWhiteHeader || _ctx.isScroll
        }])
      }, "|", 2), _createElementVNode("span", {
        class: _normalizeClass(["open-platform", {
          blackPlatform: _ctx.needWhiteHeader || _ctx.isScroll
        }])
      }, "开放平台", 2)], 2), _createElementVNode("div", _hoisted_5, [!_ctx.showPhoneHeader ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["doc", {
          whiteHeadDoc: _ctx.needWhiteHeader || _ctx.isScroll,
          selectDoc: _ctx.selectDoc
        }]),
        onClick: _cache[1] || (_cache[1] =
        //@ts-ignore
        (...args) => _ctx.openDoc && _ctx.openDoc(...args))
      }, " 开发与帮助文档 ", 2)) : _createCommentVNode("", true), !_ctx.showPhoneHeader ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["login", {
          whiteHeadLogin: _ctx.needWhiteHeader || _ctx.isScroll
        }]),
        onClick: _cache[2] || (_cache[2] =
        //@ts-ignore
        (...args) => _ctx.login && _ctx.login(...args))
      }, _toDisplayString(_ctx.isLogin ? '进入管理平台' : '开发者登录'), 3)) : _createCommentVNode("", true), _ctx.showPhoneHeader && (_ctx.needWhiteHeader || _ctx.isScroll) ? (_openBlock(), _createElementBlock("img", {
        key: 2,
        src: _imports_2,
        onClick: _cache[3] || (_cache[3] = $event => _ctx.showDrawer()),
        alt: ""
      })) : _createCommentVNode("", true), _ctx.showPhoneHeader && !_ctx.needWhiteHeader && !_ctx.isScroll ? (_openBlock(), _createElementBlock("img", {
        key: 3,
        src: _imports_3,
        onClick: _cache[4] || (_cache[4] = $event => _ctx.showDrawer()),
        alt: ""
      })) : _createCommentVNode("", true)])])]),
      _: 1
    }, 8, ["class"]), _createVNode(_component_el_drawer, {
      modelValue: _ctx.drawer,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.drawer = $event),
      "with-header": false
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
        class: "logo",
        onClick: _cache[5] || (_cache[5] =
        //@ts-ignore
        (...args) => _ctx.home && _ctx.home(...args)),
        src: _imports_1,
        alt: ""
      }), _hoisted_7, _createElementVNode("span", {
        class: "blackPlatform",
        onClick: _cache[6] || (_cache[6] =
        //@ts-ignore
        (...args) => _ctx.home && _ctx.home(...args))
      }, "开放平台")]), _createElementVNode("ul", _hoisted_8, [_createElementVNode("li", {
        onClick: _cache[7] || (_cache[7] =
        //@ts-ignore
        (...args) => _ctx.openDoc && _ctx.openDoc(...args)),
        class: _normalizeClass({
          selectDoc: _ctx.selectDoc
        })
      }, "开发与帮助文档", 2), _createElementVNode("li", {
        onClick: _cache[8] || (_cache[8] =
        //@ts-ignore
        (...args) => _ctx.login && _ctx.login(...args))
      }, _toDisplayString(_ctx.isLogin ? '进入管理平台' : '开发者登录'), 1)])]),
      _: 1
    }, 8, ["modelValue"]), _createVNode(_component_el_container, {
      class: "website-content"
    }, {
      default: _withCtx(() => [_createVNode(_component_router_view)]),
      _: 1
    }), _createVNode(_component_Login, {
      ref: "login"
    }, null, 512)]),
    _: 1
  })]);
}